import React, { useRef } from "react";
import {
  Container,
  Container1,
  Container2,
  Container3,
  ImgBox1,
  ImgBox2,
  ImgBox3,
  TextBox1,
  TextBox2,
  TextBox3,
  Wrapper1,
  Wrapper2,
  Wrapper3,
} from "./style";
import { useNavigate } from "react-router";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com3 = () => {
  const nav = useNavigate();
  const navHandler = (to) => {
    nav(to);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const isPc = useMediaQuery({
    query: "(min-width:900px)",
  });
  const { t } = useTranslation("sketchWallet");
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();

  useScrollFadeIn(ref1, ref2, ref3);
  return (
    <Container>
      <Wrapper1>
        <Wrapper2>
          <Container1 ref={ref1} className="fade-in">
            <ImgBox1 loading="lazy">
              <img
                loading="lazy"
                src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/f8e9c6ccSketchWallet_1.svg"
                alt="service1"
              />
            </ImgBox1>
            <TextBox1>
              <div>{t("3-1")}</div>
              <div>{t("3-2")}</div>
              <div>
                <span>{t("3-3")}</span>
                <span>{t("3-4")}</span>
              </div>
              <div onClick={() => navHandler("/how_to_get_sketch")}>{t("3-5")}</div>
            </TextBox1>
          </Container1>
          {isPc ? (
            <Container3 ref={ref3} className="fade-in">
              <ImgBox3 loading="lazy">
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/a4a7eab0SketchWallet_3.svg"
                  alt="service3"
                />
              </ImgBox3>
              <TextBox3>
                <div>{t("3-6")}</div>
                <div>{t("3-7")}</div>
                <div>
                  <span>{t("3-8")}</span>
                  <span>{t("3-8-1")}</span>
                  <span>{t("3-9")}</span>
                </div>
                <div onClick={() => navHandler("/who_is_creator")}>{t("3-10")}</div>
              </TextBox3>
            </Container3>
          ) : (
            <Container2 ref={ref2} className="fade-in">
              <ImgBox2 loading="lazy">
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/79f96b48SketchWallet_2.svg"
                  alt="service2"
                />
              </ImgBox2>
              <TextBox2>
                <div>{t("3-11")}</div>
                <div>{t("3-12")}</div>
                <div>
                  <span>{t("3-13")}</span>
                  <span>{t("3-14")}</span>
                </div>
                <div onClick={() => navHandler("/sketch_pay")}>{t("3-15")}</div>
              </TextBox2>
            </Container2>
          )}
        </Wrapper2>
        <Wrapper3>
          {isPc ? (
            <Container2 ref={ref2} className="fade-in">
              <ImgBox2 loading="lazy">
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/79f96b48SketchWallet_2.svg"
                  alt="service2"
                />
              </ImgBox2>
              <TextBox2>
                <div>{t("3-11")}</div>
                <div>{t("3-12")}</div>
                <div>
                  <span>{t("3-13")}</span>
                  <span>{t("3-14")}</span>
                </div>
                <div onClick={() => navHandler("/sketch_pay")}>{t("3-15")}</div>
              </TextBox2>
            </Container2>
          ) : (
            <Container3 ref={ref3} className="fade-in">
              <ImgBox3 loading="lazy">
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/a4a7eab0SketchWallet_3.svg"
                  alt="service3"
                />
              </ImgBox3>
              <TextBox3>
                <div>{t("3-6")}</div>
                <div>{t("3-7")}</div>
                <div>
                  <span>{t("3-8")}</span>
                  <span>{t("3-8-1")}</span>
                  <span>{t("3-9")}</span>
                </div>
                <div onClick={() => navHandler("/who_is_creator")}>{t("3-10")}</div>
              </TextBox3>
            </Container3>
          )}
        </Wrapper3>
      </Wrapper1>
    </Container>
  );
};

export default Com3;
